import { loadYoutubeApi } from '../../js/helper';

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$contentVideos = $context.querySelectorAll('[data-contentvideo="root"]');
        const $$howToVideos = $context.querySelectorAll('[data-howtovideos="root"]');
        const $$mediaSlider = $context.querySelectorAll('[data-mediaslider-video="root"]');

        const removeRestriction = (media) => {
            if (media) {
                const $placeholder = media.querySelector('.media__restriction');

                if ($placeholder) {
                    $placeholder.remove();
                }
            }
        };

        const showRestriction = (media) => {
            if (media) {
                const $placeholder = media.querySelector('.media__restriction');

                if ($placeholder) {
                    $placeholder.classList.add('is--shown');
                }
            }
        };

        if ($$contentVideos.length > 0 || $$howToVideos.length > 0 || $$mediaSlider.length > 0) {
            const waitForConsent = setInterval(() => {
                if (typeof CookieConsent !== 'undefined') {
                    clearInterval(waitForConsent);
                    if (CookieConsent.consent.marketing === true) { // eslint-disable-line
                        loadYoutubeApi();

                        window.onYouTubeIframeAPIReady = () => {
                            if ($$contentVideos.length > 0) {
                                import('../../modules/content-video/content-video').then(({ ContentVideo }) => {
                                    $$contentVideos.forEach((media, i) => {
                                        if (media.classList.contains('is--initialized')) {
                                            return;
                                        }
                                        const contentVideoAPI = new ContentVideo(media);
                                        media.API = contentVideoAPI;
                                        media.classList.add('is--initialized');
                                        removeRestriction(media);
                                    });
                                });
                            }

                            if ($$howToVideos.length > 0) {
                                import('../../modules/how-to-videos/how-to-videos').then(({ HowToVideos }) => {
                                    $$howToVideos.forEach((media, i) => {
                                        if (media.classList.contains('is--initialized')) {
                                            return;
                                        }
                                        const howToVideosAPI = new HowToVideos(media, {
                                            loader: window.OPTIONS.loader,
                                            resizeHandler: window.resizeHandler
                                        });
                                        media.API = howToVideosAPI;
                                        media.classList.add('is--initialized');

                                        media.querySelectorAll('.tab-bar__content-item').forEach(($wrapper) => {
                                            removeRestriction($wrapper);
                                        });
                                    });
                                });
                            }

                            if ($$mediaSlider.length > 0) {
                                import('../../modules/media-slider/media-slider').then(({ MediaSlider }) => {
                                    $$mediaSlider.forEach((media, i) => {
                                        if (media.classList.contains('is--initialized')) {
                                            return;
                                        }
                                        const mediaSlider = new MediaSlider(media);
                                        mediaSlider.initialize();
                                        media.API = mediaSlider;
                                        media.classList.add('is--initialized');
                                        removeRestriction(media);
                                    });
                                });
                            }
                        };
                    } else {
                        if ($$contentVideos.length > 0) {
                            $$contentVideos.forEach((media) => {
                                showRestriction(media);
                            });
                        }

                        if ($$howToVideos.length > 0) {
                            $$howToVideos.forEach((media) => {
                                showRestriction(media);
                            });
                        }

                        if ($$mediaSlider.length > 0) {
                            $$mediaSlider.forEach((media) => {
                                showRestriction(media);
                            });
                        }
                    }
                } else {
                    console.log('waiting for CookieContent');
                }
            }, 300);

            // timout if cookie consent is not defined - to prevent a permanent loop in the terminal
            setTimeout(() => {
                clearInterval(waitForConsent);
            }, 10000);
        }
    }
});
